import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import { useProduct } from '@revenuewell/front-end-bundle';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import { IContactProfile } from 'apps/wrapper/src/services/api-client/interface';
import { FC, useCallback } from 'react';
import { IconButtonStyled } from '../contact-actions.styles';

export interface CallActionProps {
  contact: IContactProfile;
  onClick?: () => void;
}

export const CallAction: FC<CallActionProps> = (props) => {
  const { contact, onClick } = props;
  const { hasProduct } = useProduct();
  const { publish } = useEventBus();

  const arePhonesValid = useCallback(() => {
    return (
      (contact.cellPhone && contact.cellPhone.length > 0) ||
      (contact.workPhone && contact.workPhone.length > 0) ||
      (contact.homePhone && contact.homePhone.length > 0)
    );
  }, [contact]);

  const handleCallClick = () => {
    const phoneNumber = contact.cellPhone ?? contact.homePhone ?? contact.workPhone;

    if (phoneNumber) {
      publish({
        messageType: 'startCall',
        data: {
          phoneNumber
        }
      });
    }
    onClick && onClick();
  };

  if (contact && arePhonesValid() && (hasProduct('phone') || hasProduct('phone1') || hasProduct('phone2')))
    return (
      <IconButtonStyled onClick={handleCallClick} size="large" sx={{ marginLeft: '10px' }}>
        <PhoneInTalkIcon color="primary" />
      </IconButtonStyled>
    );
  else return null;
};
